import classnames from "classnames";
import IconButton from "../../../base/button/icon_button";
import React from "react";
import {ContentCopy, EditOutlined, StarBorderOutlined, StarRounded} from "@mui/icons-material";
import {Fade} from "@mui/material";
import CopyToClipboard from "../../../base/copy-to-clipboard";

export const ProductChipsCodeContent = ({hovering, code, setAsDefault, settingAsDefault, buttonProps, onEditCode, canCopy, contentClassName}) => {

    return (
        <div className={classnames(
            'product-code',
            {default: code.isDefault}
        )}>
            <p className={classnames(contentClassName)}>
                {code.code ?? ""}
            </p>
            <Fade in={!!hovering && !!canCopy}>
                <span>
                    <CopyToClipboard>
                        {({copy}) =>
                            <IconButton
                                size={'small'}
                                color={'secondary'}
                                className={'ml-1'}
                                {...buttonProps}
                                onPressed={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    copy(code.code);
                                }}
                            >
                                <ContentCopy className={'icon small'}/>
                            </IconButton>
                        }
                    </CopyToClipboard>
                </span>
            </Fade>
            {
                onEditCode &&
                <IconButton
                    size={'small'}
                    color={'secondary'}
                    className={'ml-1'}
                    {...buttonProps}
                    onPressed={(e) => e.preventDefault() || e.stopPropagation() || onEditCode(code)}
                >
                    <EditOutlined className={'icon normal'}/>
                </IconButton>
            }
            {
                setAsDefault &&
                <IconButton
                    size={'small'}
                    color={'secondary'}
                    className={'ml-1'}
                    {...buttonProps}
                    disabled={settingAsDefault || buttonProps?.disabled}
                    onPressed={(e) => e.preventDefault() || e.stopPropagation() || setAsDefault(code)}
                >
                    {
                        code.isDefault
                            ? <StarRounded className={'icon normal'}/>
                            : <StarBorderOutlined className={'icon normal'}/>
                    }
                </IconButton>
            }
        </div>
    )
}

export default ProductChipsCodeContent;
